import { defineStore } from 'pinia';

const defaultState = () => ({
  visible: false,
  title: '',
  url: '',
  navBackgroundColor: ''
});

export const useWebModalStore = defineStore('web-modal', {
  state: () => defaultState(),
  actions: {
    open(payload = {}) {
      this.visible = true;
      this.title = String(payload.title || '').trim();
      this.url = String(payload.url || '').trim();
      this.navBackgroundColor = String(payload.navBackgroundColor || '').trim();
    },
    close() {
      this.visible = false;
    },
    reset() {
      Object.assign(this, defaultState());
    }
  }
});
